export const ERRORS_DATE = {
  INVALID_DATE: 'Invalid Date',
};
// en date format Month/Day/Year :
export const WINTER_BREAK_ENDING_DATE = '05/01/2023';
export const EXCLUDE_HIGH_LOW_ELECTRICITY_POWER = 3;

export const CAR_CONSENT_MODAL = 'carConsentModal';
